import type { Ref } from '@wix/materializer'
import type { GhostPropertiesItem } from '@wix/thunderbolt-becky-root'
import { pointers } from '@wix/thunderbolt-becky-types'
import { createRefInResolvedRefsNamespaces, isGhostPropertyItem } from '../../byRefUtils'
import { createByRefsisCompNode } from '../../compNodeUtils'

type MaybeGhostPropertyItem = GhostPropertiesItem | undefined

export const isGhostComponent = createByRefsisCompNode<Ref<MaybeGhostPropertyItem>, boolean>({
	getDependencies: ({ propertyQuery }) =>
		createRefInResolvedRefsNamespaces<MaybeGhostPropertyItem>(pointers.data.DATA_MAPS.PROPERTIES, propertyQuery!),
	toViewItem: (__, propertyItem) => isGhostPropertyItem(propertyItem),
})
